import React, { useEffect } from 'react';
import { useState } from "react";


export default function CollapseComponent(props) {
  const [expand, setExpand] = useState(false);
  const [selector, setSelector] = useState(null);
  const [expandKey, setExpandKey] = useState(null);
  const [expandSelector, setExpandSelector] = useState(null);
  const [data, setData] = useState(null);
  const [type, setType] = useState('view');
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setData(props.data || null);
    setSelector(props.selector || null);
    setExpandKey(props.expandKey || null);
    setExpandSelector(props.expandSelector || null);
    setType(props.type);
    setExpand(props.data.checked);
    if (props.data.id === props.locationId) {
      props.selectedLocation(props.data);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setType(props.type);
  }, [props.type]);

  useEffect(() => {
    if (data) {
      if (props.emitLocationsFields) {
        props.emitLocationsFields({
          location: {
            title: data.title,
            id: data.id,
          },
          fields,
        });
      }
    }
    //eslint-disable-next-line
  }, [fields]);

  useEffect(() => {
    if (!expand) {
      setFields([]);
      if (data) {
        data[expandKey].forEach(obj => (obj.checked = false));
        setData(prev => ({ ...prev, [expandKey]: data[expandKey] }));
      }
    }
    //eslint-disable-next-line
  }, [expand]);

  const handleFieldsChange = () => {
    const field_ = (function (x) {
      return x.filter(fiel => fiel.checked);
    }(data && Array.isArray(data.fields) ? data.fields : []));
    setFields(field_);
  }

  useEffect(() => {
    handleFieldsChange();
    if (props.emitSelectionForDelete) {
      if (data) {
        props.emitSelectionForDelete(data);
      }
    }
    //eslint-disable-next-line
  }, [data]);

  return (
    <>
      {
        data &&
        <div className={`parent-blk ${expand && props.type === 'view' ? 'active' : ''}`}>
          <div className="parent-header" style={{ cursor: 'pointer', }} onClick={
            () => {
              if (props.selectedLocation && props.type === 'modify') {
                props.selectedLocation(data);
              }
            }
          }>
            <label className="checkbox" style={(
              () => {
                const style = {};
                if (type === 'modify') {
                  style['paddingLeft'] = '4px';
                }
                return style;
              }
            )()}>
              {data[selector]}
              {
                type === 'view' &&
                <>
                  <input type="checkbox" defaultChecked={expand} onClick={() => {
                    setExpand(o => !o);
                    setData(prev => ({ ...prev, checked: !prev.checked }));
                  }} />
                  <span className="checkmark"></span>
                </>
              }
            </label>
            <span className="collapsible-arrow"></span>
          </div>
          {
            data[expandKey] &&
              data[expandKey].length ? data[expandKey].map((expandData, idx_) =>
              (
                <div key={`fields-${expandData.id}-${data.id}`} className="collapsible-blk">
                  <div className="child-blk">
                    <label className="checkbox"
                      style={(
                        () => {
                          const style = {};
                          if (type === 'modify') {
                            style['paddingLeft'] = '4px';
                          }
                          return style;
                        }
                      )()}>
                      {expandData[expandSelector]}
                      {
                        type !== 'modify' &&
                        <>
                          <input type="checkbox" defaultChecked={data[expandKey][idx_].checked} onClick={() => {
                            data[expandKey][idx_].checked = !data[expandKey][idx_].checked;
                            setData(prev => ({ ...prev, [expandKey]: data[expandKey] }));
                          }} />
                          <span className="checkmark"></span>
                        </>
                      }
                    </label>
                  </div>
                </div>
              ))
              : <></>
          }
        </div>
      }
    </>
  );
}